/** Clé TOTP lisible à recopier : groupes de 4 caractères (« JBSW Y3DP … »). */
export function formatTotpSecret(secret: string): string {
    return secret.match(/.{1,4}/g)?.join(' ') ?? secret;
}
